import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { Spring, Transition } from 'react-spring';
import cx from 'classnames';

import animations, { animationDirection } from 'app/constants/animations';

import Selectors from 'app/redux/ui/questions/selectors';
import { Actions } from 'app/redux/ui/questions/actions';

import Question from 'app/components/Question';
import Notice from 'app/components/Notice';

import styles from './styles.css';

class Questions extends PureComponent {
  state = {
    currentQuestionIndex: 0,
    currentNoticeIndex: 0,
    isGoingForward: undefined,
    willShowNotice: true,
    willShow:
      !this.props.isWorking && !!this.props.questionCount ? true : false,
  };

  componentDidMount() {
    const { initialize } = this.props;

    initialize();

    this.noticeTimer = setTimeout(() => {
      this.setState({
        willShowNotice: false,
      });
    }, 4000);
  }

  componentDidUpdate(prevProps) {
    const { questionCount } = this.props;

    if (!prevProps.questionCount && !!questionCount) {
      this.checkForCachedAnswers();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.noticeTimer);
    this.noticeTimer = null;
  }

  noticeTimer: null;

  checkForCachedAnswers = () => {
    const { questionIdsArray, selectedAnswers } = this.props;

    questionIdsArray.some((questionId, i) => {
      if (!selectedAnswers[questionId]) {
        this.setState({
          currentQuestionIndex: i,
          willShow: true,
        });

        return true;
      }
    });
  };

  handleOnNextClick = () => {
    const { currentQuestionIndex } = this.state;

    this.setState({
      currentQuestionIndex: currentQuestionIndex + 1,
      isGoingForward: true,
    });
  };

  handleGoBackOnClick = () => {
    const { currentQuestionIndex } = this.state;

    this.setState({
      currentQuestionIndex: currentQuestionIndex - 1,
      isGoingForward: false,
    });
  };

  renderQuestionDots = () => {
    const { questionIdsArray } = this.props;
    const { currentQuestionIndex } = this.state;

    return questionIdsArray.map((dot, index) => {
      const dotClasses = cx({
        [styles.questionDot]: true,
        [styles.questionDotIsActive]: index === currentQuestionIndex,
      });

      return <span className={dotClasses} key={dot} />;
    });
  };

  renderQuestion = () => {
    const {
      questionCount,
      questionIdsArray,
      questionResults,
      selectedAnswers,
    } = this.props;
    const { currentQuestionIndex, isGoingForward } = this.state;

    const currentQuestionId = questionIdsArray[currentQuestionIndex];
    const currentQuestion = questionResults[currentQuestionId];
    const isLastQuestion = currentQuestionIndex + 1 === questionCount;
    const transitionOptions = isGoingForward
      ? animationDirection.FORWARD
      : animationDirection.BACKWARD;

    return (
      <Transition
        config={animations.easing}
        keys={currentQuestionId}
        from={animations.pagerFrom[transitionOptions]}
        enter={animations.pagerEnter[transitionOptions]}
        leave={animations.pagerLeave[transitionOptions]}
      >
        {styles => (
          <div style={styles}>
            <Question
              data={currentQuestion}
              handleOnAnswerClick={this.handleOnNextClick}
              isLastQuestion={isLastQuestion}
              key={currentQuestionId}
              questionCount={questionCount}
              selectedAnswers={selectedAnswers}
            />
          </div>
        )}
      </Transition>
    );
  };

  getCategoryTheme = () => {
    const { categoryOptions, questionIdsArray, questionResults } = this.props;
    const { currentQuestionIndex } = this.state;

    if (!questionIdsArray || !categoryOptions || !questionResults) {
      return;
    }
    const currentCategoryId =
      questionResults[questionIdsArray[currentQuestionIndex]].category[0];
    const categoryDetail = categoryOptions[currentCategoryId];

    return categoryDetail.category;
  };

  containerThemeMap = {
    Availability: 'blueLight',
    Boundaries: 'greenDark',
    Kindness: 'green',
    Stability: 'blue',
  };

  render() {
    const { isWorking, notice, questionIdsArray, questionResults } = this.props;
    const { currentQuestionIndex, willShowNotice, willShow } = this.state;

    const category = this.getCategoryTheme();

    const containerClasses = cx(
      {
        [styles.container]: true,
      },
      this.containerThemeMap[category]
    );
    const goBackButtonClasses = cx({
      [styles.goBackButton]: true,
      [styles.goBackButtonIsInactive]: currentQuestionIndex <= 0,
    });

    if (isWorking || !willShow || !questionResults || !questionIdsArray) {
      return null;
    }

    return (
      <div className={containerClasses}>
        <div className={styles.inner}>
          <Spring
            config={animations.noticeEasing}
            from={
              willShowNotice ? animations.noticeFrom : animations.noticeEnter
            }
            to={
              willShowNotice ? animations.noticeEnter : animations.noticeLeave
            }
          >
            {styles => (
              <div className={styles.noticeContainer} style={styles}>
                <Notice {...notice} />
              </div>
            )}
          </Spring>

          {!willShowNotice && (
            <Fragment>
              <button
                onClick={this.handleGoBackOnClick}
                className={goBackButtonClasses}
              >
                Go back
              </button>
              <div className={styles.questions}>{this.renderQuestion()}</div>
              <div className={styles.dotContainer}>
                {this.renderQuestionDots()}
              </div>
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  initialize: () => dispatch(Actions.initialize()),
});

export default connect(Selectors, mapDispatchToProps)(Questions);



// WEBPACK FOOTER //
// ./src/routes/Questions/index.js